import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import { registerLocale } from "react-datepicker";
import id from 'date-fns/locale/id'
import { 
  getForm, 
  getKabupaten, 
  getKecamatan, 
  getProvinsi, 
  updateBiodata, 
  uploadPhoto,
  setPurchasEventSent 
} from "./Api";
import { notifyError, notifySuccess } from "../../utils/Notification";
import UploadPhotoDialog from "./UploadPhotoDialog";
import { setIsHomeProcess, setMember } from "../../app/GlobalSlice";
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils";
import { getSessionProfile, logout } from "../../app/Api";
import { useNavigate } from "react-router";
import FormBuilder from "./FormBuilder";
import { isPhone } from "../../utils/PlatformHelper";
import TagManager from 'react-gtm-module'

function toIsoDate(date) {
  return date.getFullYear() + '-' + padZero(date.getMonth() + 1) + '-' + padZero(date.getDate().toString())
}

function padZero(n) {
  return String(n).padStart(2, '0')
}

const BiodataPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const {
    member,
    systemProfile,
    screenSize
  } = useSelector(state => state.global)

  useEffect(() => {
    document.body.style.backgroundColor = isPhone(screenSize.width) ? 'white' : '#232745';
  }, [screenSize.width])

  const [uploadPhotoDialog, setUploadPhotoDialog] = useState({
    isOpen: false
  })

  const [refetchProfile, setRefetchProfile] = useState(false)

  const [formFields, setFormFields] = useState([])

  const [hashImage, setHashImage] = useState(Date.now());

  const [form, setForm] = useState({
    fullName: '',
    birthPlace: '',
    birthDay: Date.now(),
    allergies: '',
    illness: '',
    fullAddress: ''
  })

  const [jenisKelaminOpts, setJenisKelaminOpts] = useState({
    selectedOpt: null,
    data: [{ label: 'Laki-laki', value: 'laki-laki' }, { label: 'Perempuan', value: 'perempuan' }],
  })

  const [provinsiOpts, setProvinsiOpts] = useState({
    selectedOpt: null,
    data: [],
    isLoad: false
  })

  const [kabupatenOpts, setKabupatenOpts] = useState({
    selectedOpt: null,
    data: [],
    isLoad: false
  })

  const [kecamatanOpts, setKecamatanOpts] = useState({
    selectedOpt: null,
    data: [],
    isLoad: false
  })

  useEffect(() => {
    if (member && member.purchaseEventSent === 0) {
      //send ads event purchase
      if (window._PIXEL_ID) {
        window.fbq('track', 'Purchase', {
          currency: "IDR",
          value: member.biayaPendaftaran
        });
      }
  
      if (window._GTM_TAG) {
        const tagManagerArgs = {
          dataLayer: {
            event: 'purchase', // event to be picked up by GTM
            payload: {
              currency: "IDR",
              value: member.biayaPendaftaran
            }
          }
        }
  
        TagManager.dataLayer(tagManagerArgs);
      }

      setPurchasEventSent() //just ignore result
    }

  }, [member])

  useEffect(() => {
    document.body.style.backgroundColor = '#232745';

    getForm()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setFormFields(payload)
          },
          onRecovFailure: errors => errors.forEach(err => {
            notifyError(err)
          }),
          onUnAuth: error => {
            
          },
          onTechnicalError: errors => errors.forEach(err => {
            notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => {})

  }, [])

  useEffect(() => {
    if (!member) return;

    setForm({
      ...form,
      fullName: member.namaParticipant,
    })

  }, [member])

  useEffect(() => {
    if (!refetchProfile) return;

    dispatch(setIsHomeProcess(true))

    getSessionProfile()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            dispatch(setMember(payload))
            setRefetchProfile(false)
          },
          onRecovFailure: errors => errors.forEach(err => {
            notifyError(err)
          }),
          onUnAuth: error => {
            
          },
          onTechnicalError: errors => errors.forEach(err => {
            notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => {
        dispatch(setIsHomeProcess(false))
      })


  }, [refetchProfile])


  function onSelectProvinsiOpts() {
    setProvinsiOpts({ ...provinsiOpts, isLoad: true })

    getProvinsi()
      .then(response => {
        if (response.success) {
          const data = response.payload.map(d => ({ label: d.label, value: d.id }))
          setProvinsiOpts({ ...provinsiOpts, data: data, isLoad: false })
        }
        else {
          setProvinsiOpts({ ...provinsiOpts, isLoad: false })
        }
      })
      .catch(error => {
        setProvinsiOpts({ ...provinsiOpts, isLoad: false })
        handleAxiosNetworkError(error)
      })
  }

  function onSelectKabupatenOpts() {
    if (!provinsiOpts.selectedOpt) return;

    setKabupatenOpts({ ...kabupatenOpts, isLoad: true })

    getKabupaten(provinsiOpts.selectedOpt.value)
      .then(response => {
        if (response.success) {
          const data = response.payload.map(d => ({ label: d.label, value: d.id }))
          setKabupatenOpts({ ...kabupatenOpts, data: data, isLoad: false })
        }
        else {
          setKabupatenOpts({ ...kabupatenOpts, isLoad: false })
        }
      })
      .catch(error => {
        setKabupatenOpts({ ...kabupatenOpts, isLoad: false })
        handleAxiosNetworkError(error)
      })
  }

  function onSelectKecamatanOpts() {
    if (!kabupatenOpts.selectedOpt) return;

    setKecamatanOpts({ ...kecamatanOpts, isLoad: true })

    getKecamatan(kabupatenOpts.selectedOpt.value)
      .then(response => {
        if (response.success) {
          const data = response.payload.map(d => ({ label: d.label, value: d.id }))
          setKecamatanOpts({ ...kecamatanOpts, data: data, isLoad: false })
        }
        else {
          setKecamatanOpts({ ...kecamatanOpts, isLoad: false })
        }
      })
      .catch(error => {
        setKecamatanOpts({ ...kecamatanOpts, isLoad: false })
        handleAxiosNetworkError(error)
      })
  }

  function onUploadPhoto(file) {
    dispatch(setIsHomeProcess(true))

    uploadPhoto(file)
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Unggah Photo Berhasil')
            setRefetchProfile(true)
            setUploadPhotoDialog({
              isOpen: false
            })
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => dispatch(setIsHomeProcess(false)))
  }

  function onFinish() {
    dispatch(setIsHomeProcess(true))

    const payload = {
      fullName: form.fullName,
      jenisKelamin: jenisKelaminOpts.selectedOpt.value,
      birthPlace: form.birthPlace,
      birthDay: toIsoDate(form.birthDay),
      allergies: form.allergies,
      illness: form.illness,
      provinsi: provinsiOpts.selectedOpt.value,
      kabupaten: kabupatenOpts.selectedOpt.value,
      kecamatan: kecamatanOpts.selectedOpt.value,
      fullAddress: form.fullAddress
    }

    updateBiodata(payload)
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Berhasil update biodata')
            navigate("/home/document")
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => dispatch(setIsHomeProcess(false)))

  }

  function onLogout() {
    dispatch(setIsHomeProcess(true))

    logout()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Logout Berhasil')
            navigate("/login")
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => { dispatch(setIsHomeProcess(false)) })
  }

  if (member === null) {
    return (
      <div
        className="h-screen"
      >

        <div
          className="py-10 flex justify-center"
        >
          
          <div
            className="relative rounded-sm flex"
            style={{
              width: isPhone(screenSize.width) ? '100%' : '650px',
              // height: '700px'
            }}
          >
            
            <div
              className="flex-1 bg-white p-10"
            />
          </div>
          

        </div>
      </div>
    )
  }

  if (!systemProfile) return null;

  return (
    <>
    <div
      className="h-screen"
    >
      {uploadPhotoDialog.isOpen && (
          <UploadPhotoDialog 
            onClose={() => setUploadPhotoDialog({
              isOpen: false
            })}
            onFileSelected={onUploadPhoto}
          />
      )}
      <div
        className="py-10 flex justify-center"
      >

        <div
          className="relative rounded-sm flex"
          style={{
            width: '650px',
          }}
        >
          <div
            className="flex-1 bg-white"
          >
            <div
              className="py-5 pt-8 text-center uppercase font-bold" 
              style={{
                fontFamily: 'Nunito',
                fontSize: '20px'
              }}
            >
              <label>Tahap Pengisian Biodata</label>
            </div>
            <div
              className="flex justify-center py-5"
            >
              <img src={systemProfile.companyLogo + '?' + hashImage} width={'250px'}/>
            </div> 
            <div
              className="pb-5 border-t border-bspace-y-5"
            >
              {member.photo === null && (
                <div
                  className="bg-gray-100 py-2 text-center"
                  style={{
                    fontSize: '14px'
                  }}
                >
                  Anda perlu mengunggah photo profil Calon Murid sebelum menigisi biodata
                </div>
              )}
              <div className="flex justify-center py-5">
                {
                  member.photo ?
                    <img src={member.photo + '?' + Date.now()} width="100px"/> 
                    :
                    (<div
                      className="w-1/2 bg-gray-300 rounded-md"
                      style={{
                        height: '100px'
                      }}
                    >
                    </div>)
                }
              </div>
              <div
                className="flex justify-center"
              >
                <button 
                  className="py-1.5 px-10 bg-blue-500 text-white rounded-md"
                  style={{
                    fontSize: '14px'
                  }}
                  onClick={() => setUploadPhotoDialog({ isOpen: true })}
                >
                  Pilih File
                </button>
              </div>
            </div>

            <FormBuilder
              groupedFields={formFields}
            />

          </div>

        </div>

      </div>
    </div>
    </>
  )




}

export default BiodataPage;